import React, { useState } from 'react';
import { connect } from 'react-redux';
import '../../assets/css/servermanagement.css';
import { useEffect } from 'react';
import { ChevronLeft, FileCopy, Payment, PlaceRounded, PlayArrow, ShowChart, StorageOutlined, SupervisedUserCircle, Work } from '@material-ui/icons';
// import Schedule from './EditSchedule/Schedule';
import ApiConnect from '../common/ApiConnect';
import { Footer } from '../common/Footer';
import GenWiz from '../common/Popups/Genwizui';
import FormView from '../common/CommonComponents/FormView';
import FormEdit from '../common/CommonComponents/FormEdit';
import LlmDetails from './Misc/LlmDetails';
import UpdateTags from './Misc/UpdateTags';
import ServerTableView from './ServerList/ServerTableView';
import Termination from './Misc/Termination';
import base from '../../config';

const ServerManagement = ({
  isloading
}) => {
  //once load
  let initLoad = false;
  //genwizard ui
  const [gwconfig, setgenwiz] = useState({ stateFunction: setgenwiz });
  //redux state
  const [activeTab, setActiveTab] = useState('Container');

  const [itemData, setItemData] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showTermination, setShowTermination] = useState(false);
  const [showOpenAiDetails, setShowOpenAiDetails] = useState(false);
  const [openAiData, setOpenAiData] = useState({})
  const [showSched, setShowSched] = useState(false);
  const [serverList, setServerList] = useState([]);
  const [serverTerminationList, setServerTerminationList] = useState([]);
  const [tempList, setTempList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [serverSelected, setServerSelected] = useState([]);
  const [filters, setFilters] = useState({
    caas_orderItemUid: '',
    caas_clientName: '',
    caas_environment: '',
    caas_region: '',
    caas_state: '',
    caas_camEnv: '',
    caas_vendorName: ''
  });



  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  const resetFilters = () => {
    setFilters({
      // privateDNSName: '',
      // orderid: '',
      // clientname: '',
      // environment: '',
      // regionAlias: '',
      // instanceState: '',
      // platformtype: 'dedicated',
      // InstanceType: '',
      // accountType: '',
      // assetname: ''
    });

    const fields = document.querySelectorAll('.filter-input');
    fields.forEach((item) => {
      item.value = '';
    })
  };

  const setFormData = (item) => {
    setShowForm(true);
    let alterData = { ...item };
    const [year, month, day] = item['caas_sed'].split('T')[0].split('-');
    alterData.caas_sed = `${year}-${month}-${day}`;
    //change the environment data to to lowercase
    alterData.caas_environment = item['caas_environment'].toLowerCase();
    setItemData(alterData);
  }

  const setTerminationData = (item) => {
    setServerSelected(item);
    setShowTermination(true);
    let alterData = { ...item };
    setItemData(alterData);
  }

  const setSelectServer = (item) => {
    const value = item.value;
    const core = itemData.caas_appcore.split(',')
    let appCore = [...serverTerminationList];
    if (item.checked === true) {
      if (!appCore.includes(value)) {
        appCore.push(value)
      }
    } else {
      appCore = appCore.filter(val => val !== value);
    }

    if (appCore.includes('CUI')) {
      if (core.includes('AD') && !appCore.includes('UTKM'))
        appCore.push('AD')
      if (core.includes('UTKM') && !appCore.includes('UTKM'))
        appCore.push('UTKM')
    } else if (item.value === 'CUI') {
      const remove = new Set(['AD', 'UTKM']);
      appCore = appCore.filter(item => !remove.has(item))
    }

    if (appCore.includes('AD')) {
      if (core.includes('UTKM') && !appCore.includes('UTKM'))
        appCore.push('UTKM')
    }

    if (appCore.includes('KM')) {
      if (core.includes('UTKM') && !appCore.includes('UTKM'))
        appCore.push('UTKM')
    }

    setServerTerminationList(appCore);
  }

  // const setPopUp = (item) => {
  //   setgenwiz({
  //     appName: 'gwForm',
  //     config: {
  //       height: 'auto',
  //       stateFunction: setgenwiz,
  //       text: 'User Notes',
  //       type: 'textarea',
  //       bntSubmit: async (data) => { }
  //     },
  //   });
  // }
  const setPopUp = () => {
    let coreInstance = itemData.caas_appcore.split(",");
    const coreDecom = [];
    const appName = itemData.caas_productName;
    let pUMessage = <>Are you sure you want to terminate <br /><span style={{ fontWeight: '500', color: '#761EA0' }}>{appName}</span> instance?</>;
    //filter if the core instance if present on the list
    serverTerminationList.map(item => {
      if (coreInstance.includes(item))
        coreDecom.push(item);
    });

    if (appName === "Genwizard Agent") {
      pUMessage = <>Are you sure want to Terminate<br /><span style={{ fontWeight: '500', color: '#761EA0' }}>{appName}<br />{coreDecom.join(',')} instance(s)?</span></>;
    }
    setgenwiz({
      appName: 'gwConfirm',
      config: {
        stateFunction: setgenwiz,
        text: pUMessage,
        onloop: true,
        width: 360,
        height: 220,
        bntYes: () => {
          terminateInstance();
        }
      },
    });
  }

  const tableButton = (evt) => {
    evt.stopPropagation();
    const curdiv = evt.target.closest("td").querySelector(".table-menu");
    if (curdiv.style.display === "block") {
      curdiv.style.display = "none";
    } else {
      const alldiv = document.getElementsByClassName("table-menu");
      for (let i = 0; i < alldiv.length; i++) alldiv[i].style.display = "none";
      curdiv.style.display = "block";
    }
  };

  //fetch the data on api gateway
  const fetchData = () => {
    const idToken = localStorage.getItem("token");
    ApiConnect.get(
      'fui/orders/genwizard4', {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    }
    ).then(resp => {
      if (resp.data.length === 0)
        setIsLoading(false);
      else
        setTempList(resp.data);
    }).catch(err => {
      setIsLoading(false);
      console.log(err);
    })
  }

  //new tab genwizard ai
  const genwizardAI = (contractid, environment) => {
    //init loading
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Fetching Data',
      }
    });
    //fetch data
    const idToken = localStorage.getItem("token");
    ApiConnect.get(
      `/azure/openai-access/read/fetch?contractid=${contractid}&environment=${environment}`, {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    }
    ).then(resp => {
      setOpenAiData(resp.data[0]);
      //hide loading
      setgenwiz({
        status: 'hide'
      });
    }).catch(err => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Error Fetching GenAI Details',
          callback: () => { }
        }
      });
    })
  }

  //new tab genwizard ai
  const terminateInstance = () => {
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Please wait',
      }
    });
    const idToken = localStorage.getItem("token");
    const dataPost = {
      "caasid": serverSelected.caas_id,
      "customereid": serverSelected.caas_customerEID,
      "appcore": serverTerminationList.join(','),
      "orderid": serverSelected.caas_orderItemUid,
      "dcr": serverSelected.caas_dcr
    }
    ApiConnect.post(
      `/provision/caas/terminate`,
      dataPost,
      {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": idToken,
        }
      }
    ).then(resp => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Data Updated',
          callback: () => {
            setTempList(prevData => prevData.filter(item => item.caas_id !== serverSelected.caas_id));
            // fetchData();
            setServerTerminationList([])
          }
        }
      });
    }).catch(err => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Error Fetching OpenAi Details',
          callback: () => { }
        }
      });
    })
  }

  //update tags
  //new tab genwizard ai
  const updateTagInstance = (postData) => {
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Please wait',
      }
    });
    const idToken = localStorage.getItem("token");
    const dataPost = { ...postData }
    ApiConnect.put(
      `/provision/caas/updatetags/genwizard4`,
      dataPost,
      {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": idToken,
        }
      }
    ).then(resp => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Data Updated',
          callback: () => {
            fetchData();
          }
        }
      });
    }).catch(err => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Updating tag details failed',
          callback: () => { }
        }
      });
    })
  }

  useEffect(() => {
    setTimeout(() => {
      fetchData();
    }, 5000);
  }, [])


  useEffect(() => {
    const servers = tempList.filter(item =>
      Object.entries(filters).every(([key, value]) => {
        if (!value) return true;

        if (typeof item[key] === "string") {
          if (key !== 'caas_camEnv')
            return item[key].toLowerCase().includes(value.toLowerCase());
          return item[key].toLowerCase() === value.toLowerCase()
        }

        return item[key] === value;
      })
    );
    setServerList(servers);

  }, [tempList, filters])

  useEffect(() => {
    if (Object.entries(openAiData).length > 0) {
      setgenwiz({
        status: 'hide'
      });
      setShowOpenAiDetails(true);
    }
  }, [openAiData])

  useEffect(() => {
    if (tempList.length > 0)
      setIsLoading(false);
  }, [serverList])

  return (
    <>
      <div className="genwizard4">
        <div className="header">
          <div className="tabs">
            {/* <button
              className={`tab ${activeTab === 'dedicated' ? 'active' : ''}`}
              onClick={() => setActiveTab('dedicated')}
            >
              DEDICATED
            </button> */}
            <button
              className={`tab ${activeTab === 'Container' ? 'active' : ''}`}
              onClick={() => setActiveTab('Container')}
            >
              CONTAINER
            </button>
            <div className="filter-actions">
              <button className="btn btn-secondary" onClick={() => {
                resetFilters();
              }}>
                Reset Filter
              </button>
              <button className="btn btn-primary" onClick={() => {
                fetchData();
                setIsLoading(true);
              }}>
                Refresh Data
              </button>
            </div>
          </div>
        </div>
        <div className="filter-section">
          <div className="filter-grid">
            {activeTab === 'dedicated' && (
              <div className="filter-item">
                <input
                  type="text"
                  className="filter-input"
                  placeholder="Filter by Private DNS..."
                  value={filters.privateDns}
                  disabled={isloading}
                  onChange={(e) => handleFilterChange('privateDNSName', e.target.value)}
                />
              </div>
            )}
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Product Name..."
                value={filters.caas_productName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_productName', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Order ID..."
                value={filters.caas_orderItemUid}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_orderItemUid', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Client Name..."
                value={filters.caas_clientName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_clientName', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_vendorName}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_vendorName', e.target.value)}
              >
                <option value="">All Vendors</option>
                <option value="CAM">CAM</option>
                <option value="Marketplace">Market Place</option>
              </select>
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_environment}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_environment', e.target.value)}
              >
                <option value="">All Environments</option>
                <option value="prod">Production</option>
                <option value="test">Test</option>
                <option value="dev">Development</option>
              </select>
            </div>
            <div className="filter-item">
              <input
                type="text"
                className="filter-input"
                placeholder="Filter by Region..."
                value={filters.caas_region}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_region', e.target.value)}
              />
            </div>
            <div className="filter-item">
              <select
                className="filter-input"
                value={filters.caas_state}
                disabled={isloading}
                onChange={(e) => handleFilterChange('caas_state', e.target.value)}
              >
                <option value="">All Status</option>
                <option value="running">Running</option>
                <option value="stopped">Stopped</option>
                <option value="terminated">Terminated</option>
                <option value="terminating">Terminating</option>
              </select>
            </div>
          </div>
        </div>

        <div className="table-container">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  {activeTab === 'dedicated' &&
                    (<th>Private DNS</th>)
                  }
                  <th>Product Name</th>
                  <th>Order ID</th>
                  <th>Client Name</th>
                  <th className='hide-width-small'>Vendor Name</th>
                  <th>Environment</th>
                  <th>Region</th>
                  <th>Service End Date</th>
                  <th>Status</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ?
                  <React.Fragment>
                    {Array.from({ length: activeTab === 'dedicated' ? 10 : 9 }).map((_, j) => (
                      <tr className='skeleton'>
                        {Array.from({ length: activeTab === 'dedicated' ? 9 : 8 }).map((_, j) => (
                          <td><span>*******************</span></td>
                        ))}
                        <td style={{ height: '30px' }}><span>*****</span></td>
                      </tr>
                    ))}
                  </React.Fragment>
                  : serverList.length > 0 ?
                    <>
                      {serverList.map((server) => (
                        <ServerTableView data={server} setTerminationData={setTerminationData} setFormData={setFormData} genwizardAI={genwizardAI} />
                      ))}
                    </> :
                    <tr style={{ border: 'none' }}>
                      <td colSpan="10">
                        <div style={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <div style={{ textAlign: 'center' }}>
                            <h2 style={{ fontSize: '1.8rem', color: '#333333', fontWeight: '600' }}>No data found</h2>
                            <span>Try to click button the Refresh Data</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* instance edit tags */}
      <UpdateTags show={showForm} title={"Edit Tags"} width={'600px'} height={'70%'} setConfirm={setgenwiz} setShow={setShowForm} data={itemData} updateData={setItemData} saveDisabled={false} saveFunction={updateTagInstance} />
      {/* termination component */}
      <Termination data={itemData} showTermination={showTermination} setShowTermination={setShowTermination} setPopUp={setPopUp} setSelectServer={setSelectServer} serverTerminationList={serverTerminationList} />
      {/* openai details */}
      <LlmDetails show={showOpenAiDetails} title={"LLM Details"} width={'600px'} height={'80%'} setShow={setShowOpenAiDetails} data={openAiData} />
      {/* custom popup */}
      <GenWiz open={true} appconfig={gwconfig} />
    </>
  );
};

const reduxStatesData = (state) => ({
  serverList: state.servers.instancesNewTags,
  isloading: state.servers.isLoading
});

export default connect(reduxStatesData)(ServerManagement);